import styled, { css } from 'styled-components'
import { Transition, breakpoints } from 'utils/constants'
import {
  Wrapper as MenuWrapper,
  List as MenuList,
  ProjectMenuBox,
  ProjectName,
  ProjectMenuTitleStyled,
  ControlTitle,
} from './components/Menu/styled'

export const SidebarToggle = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--t-sidebar-toggle-text);
  background-color: var(--t-sidebar-button-bg);
  border-radius: 8px;
`

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 16px 0;
  justify-content: space-between;
  margin-bottom: 24px;

  @media ${breakpoints.mobileMax} {
    display: none;
  }
`

export const SidebarLogo = styled.div``

export const User = styled.div`
  padding: 0 16px;
`

export const UserHeader = styled.div`
  display: flex;
  align-items: center;
`

export const UserInfo = styled.div`
  width: calc(100% - 38px);
  padding-left: 16px;
`

export const UserAvatar = styled.div`
  width: 48px;
  height: 48px;

  img {
    margin: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
`

export const UserName = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  margin-bottom: 2px;
`

export const UserPosition = styled.div`
  color: var(--t-sidebar-user-position-text);
`

export const UserControls = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  padding-bottom: 24px;
`

export const UserLink = styled.div`
  width: 50%;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  line-height: 15px;
  cursor: pointer;
  color: var(--t-sidebar-user-link-text);
  background-color: var(--t-sidebar-button-bg);
  border-radius: 6px;
  transition: ${Transition.ms300};

  &:first-child {
    color: var(--t-sidebar-user-link-profile-text);
  }

  &:hover {
    color: var(--t-sidebar-user-link-hover-text);
  }
`

export const SidebarMenu = styled.div`
  position: relative;
  height: calc(100% - 182px);

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 16px;
    right: 16px;
    height: 1px;
    background: var(--t-sidebar-menu-bg);
  }

  [data-simplebar='init'] {
    height: 100%;
  }
`

export const SidebarRoot = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 272px;
  z-index: 10;
  color: var(--t-sidebar-text);
  background-color: var(--t-sidebar-bg);
  box-shadow: 0 0 1px 0px var(--t-sidebar-shadow-outline);
  --padding-left-content: 56px;

  ${(p) =>
    p.hide &&
    css`
      width: 56px;
      left: 0;

      ${SidebarMenu} {
        height: calc(100% - 64px);
      }

      ${User},
      ${SidebarLogo},
      ${ProjectName},
      ${ControlTitle} {
        display: none;
      }

      ${SidebarMenu} {
        &:before {
          left: 0;
          right: 0;
        }
      }

      ${MenuWrapper} {
        padding: 24px 0;
      }

      ${MenuList} {
        padding: 0 8px;
      }

      ${ProjectMenuTitleStyled} {
        justify-content: center;
      }

      ${ProjectMenuBox} {
        background: transparent;
      }
    `};

  @media ${breakpoints.mobileMax} {
    width: 100%;
    top: 48px;
    padding-top: 24px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    pointer-events: none;
    transform: translate3d(0, -100%, 0);
    transition: 0.4s transform cubic-bezier(0.165, 0.84, 0.44, 1);

    ${(p) =>
      p.opened &&
      css`
        pointer-events: all;
        transform: translate3d(0, 0, 0);
      `}
  }
`
